/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CostStatisticDto } from '../models/cost-statistic-dto';
import { getBasicCostStatistics } from '../fn/cost-statistics/get-basic-cost-statistics';
import { GetBasicCostStatistics$Params } from '../fn/cost-statistics/get-basic-cost-statistics';
import { getLaborCostStatistics } from '../fn/cost-statistics/get-labor-cost-statistics';
import { GetLaborCostStatistics$Params } from '../fn/cost-statistics/get-labor-cost-statistics';

@Injectable({ providedIn: 'root' })
export class CostStatisticsApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getBasicCostStatistics()` */
  static readonly GetBasicCostStatisticsPath = '/v0/costStatistics/basic';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBasicCostStatistics()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getBasicCostStatistics$Response(params: GetBasicCostStatistics$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CostStatisticDto>>> {
    return getBasicCostStatistics(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBasicCostStatistics$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getBasicCostStatistics(params: GetBasicCostStatistics$Params, context?: HttpContext): Observable<Array<CostStatisticDto>> {
    return this.getBasicCostStatistics$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CostStatisticDto>>): Array<CostStatisticDto> => r.body)
    );
  }

  /** Path part for operation `getLaborCostStatistics()` */
  static readonly GetLaborCostStatisticsPath = '/v0/costStatistics/labor';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLaborCostStatistics()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getLaborCostStatistics$Response(params: GetLaborCostStatistics$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CostStatisticDto>>> {
    return getLaborCostStatistics(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLaborCostStatistics$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getLaborCostStatistics(params: GetLaborCostStatistics$Params, context?: HttpContext): Observable<Array<CostStatisticDto>> {
    return this.getLaborCostStatistics$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CostStatisticDto>>): Array<CostStatisticDto> => r.body)
    );
  }

}
